import * as THREE from 'three';
import { Effect } from 'postprocessing';
import { forwardRef, useMemo } from 'react';


const fragmentShader = `
  uniform sampler2D uTexture;  // your displacement map
  // inputBuffer is provided by postprocessing: it's the rendered scene (your Text)

  void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {
    // sample displacement (scroll + tile a bit if you like)
    vec2 uv_t = vec2(uv.x + 0.25, uv.y * 0.5);
    float d = texture(uTexture, uv_t).g;

    // apply displacement to the scene buffer
    vec2 uv_displaced = vec2(uv.x - d * 0.02, uv.y + d * 0.05);
    outputColor = texture(inputBuffer, uv_displaced);
  }
`;

export class GlitchEffectImpl extends Effect {
	constructor(props) {
		super('GlitchEffect', fragmentShader, {
			uniforms: new Map([
				['uTexture', new THREE.Uniform(props.texture)],
			]),
		});
	}
}

// Effect component
export const GlitchEffect = forwardRef((props: {texture: THREE.Texture |  THREE.Texture[]}, ref) => {
	const effect = useMemo(() => new GlitchEffectImpl(props), [props]);
	return <primitive ref={ref} object={effect} dispose={null} />;
});
